import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo_short_transparent_white.png")